import { AttachapiApi, Attachment } from '@datum-group/isogd-openapi/lib';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';
import { IMAGE_MIME_TYPE } from './constant';

export class RecordAttachments {
  @observable private _attachments: Attachment[] = [];
  @observable private _tableName: string;
  @observable private _recordId: string | number;
  @observable private _isLoading = false;
  @observable private _error?: string = undefined;
  private _attachApi: AttachapiApi;

  constructor(
    tableName: string,
    recordId: string | number,
    attachApi: AttachapiApi,
  ) {
    this._attachApi = attachApi;
    this._tableName = tableName;
    this._recordId = recordId;
    makeObservable(this);
  }

  @computed get tableName() {
    return this._tableName;
  }

  @computed get recordId() {
    return this._recordId;
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @computed get error() {
    return this._error;
  }

  @computed get attachments() {
    return this._attachments.map((a) => this._clone(a));
  }

  @computed get images() {
    const attachments: Attachment[] = [];

    for (const attachment of this._attachments) {
      const type = attachment.fileinfo?.mimetype;

      if (type && IMAGE_MIME_TYPE.includes(type)) {
        attachments.push(this._clone(attachment));
      }
    }

    return attachments;
  }

  @action load = async () => {
    this._isLoading = true;
    this._error = undefined;

    try {
      const resp = await this._attachApi.apiAttachmentsList(
        '' + this._recordId,
        this._tableName,
      );
      runInAction(() => (this._attachments = resp.data.results));
    } catch (e) {
      runInAction(
        () =>
          (this._error = `Не удалось загрузить информацию о вложениях у записи ${this._recordId} в таблице ${this._tableName}`),
      );
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  };

  private _clone(attachment: Attachment): Attachment {
    const fileInfo: Attachment['fileinfo'] = attachment.fileinfo
      ? { ...attachment.fileinfo }
      : undefined;

    return { ...attachment, fileinfo: fileInfo };
  }
}
